import { cn, Tooltip, TooltipContent, TooltipTrigger } from '@design-system';
import type { PilotCapability } from '@shared';
import { useActivePilotProgram } from '@/shared/hooks/use-active-pilot-program';

interface PilotRestrictedProps {
  children: React.ReactNode;
  capability: PilotCapability;
  side?: 'top' | 'right' | 'bottom' | 'left';
  hidden?: boolean;
  className?: string;
  tooltipText?: string;
}

export function PilotRestricted({
  children,
  capability,
  side,
  hidden = false,
  className,
  tooltipText
}: PilotRestrictedProps) {
  const program = useActivePilotProgram();

  if (!program || !program.restrictedCapabilities.includes(capability)) {
    return <>{children}</>;
  }

  if (hidden) {
    return null;
  }

  return (
    <Tooltip disableHoverableContent>
      <TooltipTrigger asChild>
        <div className={cn('cursor-not-allowed', className)}>
          <div
            className="pointer-events-none opacity-50"
            aria-disabled="true"
            onKeyDown={e => e.preventDefault()}
            onFocusCapture={e => e.stopPropagation()}
            tabIndex={-1}
          >
            {children}
          </div>
        </div>
      </TooltipTrigger>
      <TooltipContent
        side={side}
        className="max-w-64"
      >
        {tooltipText ?? program.restrictedTooltip}
      </TooltipContent>
    </Tooltip>
  );
}
